import { ReactNode } from 'react';

import { Box } from 'components/Box';
import { colors } from 'theme';

type Props = {
  label: ReactNode;
  description: ReactNode;
};

export const formatOptionLabel = ({ label, description }: Props) => (
  <Box display="flex" flexWrap="wrap" margin="10px 0">
    <Box flex="0 0 auto" width={[1, null, null, 1]}>
      {label}
    </Box>
    {description && (
      <Box
        className="select-description"
        marginTop="2px"
        flex="0 0 auto"
        width={[1, null, null, 1]}
        color={`${colors.lightContentGrey}`}
        fontSize="14px"
      >
        {description}
      </Box>
    )}
  </Box>
);
